export const palette = {
  primary: {
    darkest: '#4A1F14',
    dark: '#AD4830',
    main: '#F76744',
    light: '#F9957C',
    lightest: '#FEF0EC',
  },
  secondary: {
    darkest: '#1F153A',
    dark: '#473087',
    main: '#6645C1',
    light: '#947DD4',
    lightest: '#F0ECF9',
  },
  overlays: {
    default: 'rgba(30, 32, 38, 0.6)',
    dark: '#818285',
  },
  gradient: {
    workoutBackground: 'linear-gradient(180deg, #1E2026 0%, #3A3C45 100%)',
  },
  info: {
    darkest: '#1E2026',
    dark: '#1E2026',
    main: '#4B4D51',
    light: '#E4E4E5',
    lightest: '#F8F9F9',
  },
  blue: {
    lightest: '#E7F4FF',
    dark: '#0B68B3',
  },
  green: {
    dark: '#21AB87',
    main: '#3DD5AE',
    lightest: '#D8F7EF',
  },
  orange: {
    dark: '#A45F1A',
    lightest: '#FFEEDE',
  },
  success: {
    darkest: '#003414',
    dark: '#00782F',
    main: '#00AC43',
    light: '#4DC57B',
    lightest: '#E6F7EC',
  },
  warning: {
    darkest: '#452302',
    dark: '#A15305',
    main: '#E67607',
    light: '#EE9F51',
    lightest: '#FDF1E6',
  },
  error: {
    darkest: '#460A0A',
    dark: '#A21616',
    main: '#E82020',
    light: '#EF6363',
    lightest: '#FDE9E9',
  },
  gray: {
    0: '#FFFFFF',
    3: '#F8F9F9',
    8: '#EDEEEE',
    12: '#E4E4E5',
    16: '#DBDBDC',
    40: '#A5A6A8',
    56: '#818285',
    64: '#6F7074',
    80: '#4B4D51',
    100: '#1E2026',
  },
  custom: {
    turquoise: {
      main: '#00CCC0',
      lightest: '#E6FAF9',
    },
    table: {
      main: '#303137',
    },
    button: {
      hover: '#FFFFFF',
    },
    user: {
      header: '#25272D',
      title: '#4A1F14',
      subtitle: '#D2D2D4',
      action: '#00D89F',
      background: '#1E2026',
    },
  },
  content: {
    grey: '#42A4FF',
  },
  pink: {
    lightest: '#FEEBF7',
    dark: '#A9287D',
  },
  alert: {
    danger: {
      lightest: '#FFE2E3',
      dark: '#A32326',
    },
    teal: {
      lightest: '#E0F7FA',
      dark: '#228292',
    },
    successV2: {
      lightest: '#EBF8DD',
      dark: '#528C15',
    },
    indigo: {
      lightest: '#E6E8FC',
      dark: '#29369C',
    },
  },
  aggregator: {
    main: '#0055FE',
  },
  attendance: {
    site: '#6B46C1',
    total: '#A45F1A',
  },
  toast: {
    success: {
      background: '#EBF8DD',
      border: '#528C15',
      iconBadge: '#528C15',
      shadow: '0px 2px 4px rgba(82,140,21,0.24)',
    },
    error: {
      background: '#ffe2e3',
      border: '#cd3134',
      iconBadge: '#cd3134',
      shadow: '0px 2px 4px rgba(232,32,32,0.24)',
    },
    info: {
      background: '#e6f6fc',
      border: '#818df2',
      iconBadge: '#29369c',
      shadow: '0px 1px 4px rgba(30,32,38,0.16)',
    },
  },
}
